module.exports = __webpack_public_path__ + "static/top-companies-global-2020-fb301e57401aaf7eba5d8123b9705012.png";